export var descriptions = [
    "Contact us today about this domain.",
    "Get started today.",
    "Reach out regarding this domain today.",
    "Inquire about this domain today.",
];
